import { inject, Injectable } from '@angular/core';
import { IndexType } from '@fnModels/algolia/algolia';
import { Select, Store } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { getIndex } from '@state/utils/helper';
import { filter } from 'rxjs/operators';
import { AlgoliaSearchService } from './index';

const index = getIndex(IndexType.CLIENTS);

@Injectable({ providedIn: 'root' })
export class ClientSearchService extends AlgoliaSearchService {
	protected store = inject(Store);
	@Select(BusinessUsersState.getLoggedInBusinessUser) loggedInBusinessUser$;

	constructor() {
		super();
		this.loggedInBusinessUser$
			.pipe(filter((businessUser) => !!businessUser))
			.subscribe((businessUser) => {
				const { algoliaSearchKey } = businessUser;
				console.log('Initializing Algolia search client for index', index);
				this.initialize(algoliaSearchKey, index);
			});
	}
}
